export default "__VITE_ASSET__ColIN$Cl__"